import React from 'react';
import PropTypes from 'prop-types';
import Heading from '@mapbox/mr-ui/heading';

class PageSidebar extends React.Component {
  getSectionContent(section, index) {
    let heading;
    const wrapperClasses = index === 0 ? '' : 'mt12-mm mt24-ml';

    if (section.heading) {
      heading = (
        <h6 className="mb18">
          <Heading variant="minor">{section.heading}</Heading>
        </h6>
      );
    }

    return (
      <div key={index} className={wrapperClasses}>
        {heading}
        {section.body}
      </div>
    );
  }

  render() {
    const content = this.props.sections.map(this.getSectionContent);
    return <div>{content}</div>;
  }
}

PageSidebar.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string,
      body: PropTypes.element.isRequired
    })
  ).isRequired
};

export { PageSidebar };
